import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LabelPosition, SwitchToggle } from "../../FormComponents/SwitchToggle";
import { Dropdown } from "../../FormComponents/Dropdown";
import { FormInput } from "../../FormComponents/Input/Input";

export default function CompensationForm({ form, onChange }) {
    const { t } = useTranslation();
    const months = useSelector((state) => state.CommonReducer.dropdownlists?.['CompensationMonths']);
    const reasons = useSelector((state) => state.CommonReducer.dropdownlists?.['CompensationReasons']);
    const sumLoading = useSelector((state) => state.CommonReducer.dataLoading.compensationSum);
    const data = form.data;
    const subOptions = reasons.find(r => r.id === Number(data.reasonId))?.subOptions ?? [];

    const onReasonChange = (value) => {
        onChange(value, "reasonId");
        onChange(reasons.find(r => r.id === Number(value))?.subOptions[0]?.id ?? null, "subReasonId");
    }

    const onContactCustomer = (value) => {
        if (value) {
            onChange(null, "months");
            onChange(0, "sum");
        }
        onChange(value, "contactCustomer");
    }

    const displayContactCustomer = data.restrictions.canToggleContactCustomer;

    return (
        <form className="skynet-form container">
            <div className="col m-0 p-0">
                <fieldset className="d-grid col-12 gap-16 rounded-12 p-12 shadow-10">
                    {displayContactCustomer && <SwitchToggle labelPosition={LabelPosition.RIGHT} label={t("compensationform.contactcustomer")} onChange={(value) => onContactCustomer(value)} checked={data.contactCustomer} />}
                    <Dropdown label={t("compensationform.compensationreasons")} options={reasons} onChange={onReasonChange} value={data.reasonId} required />
                    {subOptions.length > 0 &&
                        <Dropdown
                            label={t("compensationform.compensationsubreason")}
                            options={subOptions}
                            onChange={(value) => onChange(value, 'subReasonId')}
                            value={data.subReasonId}
                        />
                    }
                    {!data.contactCustomer &&
                        <>
                            <Dropdown label={t("compensationform.months")} options={months} onChange={(value) => onChange(value, "months")} value={data.months} required />
                            <FormInput label={t("compensationform.compensationsum")} value={data.sum} disabled loading={sumLoading} />
                        </>
                    }
                    <FormInput label={t("compensationform.customerphone")} onChange={(value) => onChange(value, "customerPhone")} value={data.customerPhone} />
                    <FormInput label={t("compensationform.customeremail")} onChange={(value) => onChange(value, "customerEmail")} value={data.customerEmail} />
                    <FormInput label={t("compensationform.contactperson")} onChange={(value) => onChange(value, "contactPerson")} value={data.contactPerson} />
                    <FormInput label={t("compensationform.salesforceticket")} onChange={(value) => onChange(value, "salesforceTicketLink")} required value={data.salesforceTicketLink} />
                    <FormInput label={t("compensationform.comment")} type="textarea" onChange={(value) => onChange(value, "comment")} value={data.comment} required placeholder={t("compensationform.commentplaceholder")} />
                </fieldset>
            </div>
        </form>
    )
}